<div id="outer" class="well container-fluid">
    <div class="well-title">
        <div class="col-md-12">Purchase to Pay</div>
    </div>
    <div class="col-md-12 well-content">
        <ul class="nav nav-tabs">
            @for (step of Steps | orderBy: "Order"; track step) {
                <li [ngClass]="GetClass(step)" style="cursor: pointer" role="presentation">
                    <a (click)="SelectStep(step, true)"><span [innerText]="step.StepName"></span></a>
                </li>
            }
            <li class="pull-right" style="margin-bottom: 10px">
                @if (SelectedType === 0 || SelectedType === 1 || SelectedType === 3) {
                    <button
                        [ngbTooltip]="'Export'"
                        class="btn btn-default"
                        style="font-size: 12px"
                        (click)="ExportSearchResults()">
                        <img height="16" src="assets/images/Excel.jpg" alt="Excel" /> Export
                    </button>
                }
                <!--
        <button class="btn btn-default" style="font-size: 12px" (click)="UploadInvoice()">
          Upload Invoice
        </button>
        -->
                @if (Items) {
                    <button class="btn btn-default" style="font-size: 12px" (click)="Refresh()">
                        <span style="color: green" class="fa-solid fa-arrows-rotate"></span>&nbsp;Refresh
                    </button>
                }
            </li>
        </ul>
        @if (!Loading && (!Steps || Steps.length === 0)) {
            <div style="margin-top: 15px; margin-bottom: 15px">
                <span style="color: red">This account isn't assigned any steps in the Purchase To Pay module.</span
                ><br />Contact an administrator for access.
            </div>
        }

        <!-- BEGIN DASHBOARD -->

        <div [style.display]="Items && SelectedType === 3 ? 'block' : 'none'">
            <div style="margin-top: 10px"></div>
            <!-- Dashboard search -->
            <div class="row">
                <div class="col-md-12">
                    <div class="d-flex flex-wrap align-items-center gap-2">
                        <nz-select
                            [ngModelOptions]="{standalone: true}"
                            [(ngModel)]="DashboardSearch.Field"
                            (ngModelChange)="DashboardFieldChanged()"
                            nzShowSearch
                            nzPlaceHolder="Field"
                            style="width: 160px">
                            @for (s of DashboardSearchOptions; track s) {
                                <nz-option [nzValue]="s" [nzLabel]="s.SearchOption"></nz-option>
                            }
                        </nz-select>
                        <nz-select
                            [ngModelOptions]="{standalone: true}"
                            [(ngModel)]="DashboardSearch.Operator"
                            style="width: 110px">
                            <nz-option [nzValue]="'Contains'" [nzLabel]="'Contains'"></nz-option>
                            <nz-option [nzValue]="'='" [nzLabel]="'='"></nz-option>
                            <nz-option [nzValue]="'>'" [nzLabel]="'>'"></nz-option>
                            <nz-option [nzValue]="'>='" [nzLabel]="'>='"></nz-option>
                            <nz-option [nzValue]="'<'" [nzLabel]="'<'"></nz-option>
                            <nz-option [nzValue]="'<='" [nzLabel]="'<='"></nz-option>
                        </nz-select>
                        @if (DashboardSearch.Field.SearchType !== 1) {
                            <input
                                nz-input
                                type="text"
                                [(ngModel)]="DashboardSearch.Value"
                                [ngModelOptions]="{standalone: true}"
                                (keyup.enter)="Search()"
                                style="width: 160px" />
                        }
                        @if (DashboardSearch.Field.SearchType === 1) {
                            <nz-date-picker
                                [(ngModel)]="DashboardSearch.DateValue"
                                [ngModelOptions]="{standalone: true}"
                                nzFormat="MM/dd/yyyy"
                                style="width: 160px"></nz-date-picker>
                        }
                        <label
                            nz-checkbox
                            class="mb-0 ms-1"
                            [(ngModel)]="DashboardSearch.ShowCanceled"
                            [ngModelOptions]="{standalone: true}"
                            (ngModelChange)="ToggleCanceled()">
                            Show Canceled
                        </label>
                        <nz-space-compact>
                            <button nz-button nzType="primary" (click)="Search()">Search</button>
                            <button nz-button (click)="Clear()">Clear</button>
                        </nz-space-compact>
                    </div>
                </div>
            </div>
            <!-- Leave this off for the moment -->
            <!--
            <div class="row col-md-12" style="margin-top: 10px;">
                <div
                    class="input-group-btn btn-group"
                    role="group">                    
                    <button *ngIf="HasStep('Request')" class="btn btn-success" (click)="CreateRequest('Request')">Create Request</button>
                    <button *ngIf="HasStep('PO')" class="btn btn-success" (click)="CreatePO('PO')">Create PO</button>                    
                </div>
            </div>
            -->
            <div class="row">
                <div class="col-md-2">
                    <label class="control-label" for="step">Step</label>
                    <nz-select
                        id="step"
                        nzShowSearch
                        style="width: 100%"
                        [(ngModel)]="StepFilter"
                        [ngModelOptions]="{standalone: true}"
                        (ngModelChange)="Refresh()">
                        <nz-option [nzValue]="''" nzLabel="All"></nz-option>
                        @for (step of FilterSteps; track step) {
                            <nz-option [nzValue]="step.StepID" [nzLabel]="step.StepName"></nz-option>
                        }
                    </nz-select>
                </div>
                <div class="col-md-2">
                    <label class="control-label" for="location">Location</label>
                    <nz-select
                        id="location"
                        nzShowSearch
                        style="width: 100%"
                        [(ngModel)]="LocationFilter"
                        [ngModelOptions]="{standalone: true}"
                        (ngModelChange)="Refresh()">
                        <nz-option [nzValue]="''" nzLabel="All"></nz-option>
                        @for (location of Locations; track location) {
                            <nz-option
                                [nzValue]="location.PTPShippingLocationID"
                                [nzLabel]="location.ShippingLocation"></nz-option>
                        }
                    </nz-select>
                </div>
                <div class="col-md-2">
                    <label class="control-label" for="requestedBy">Requested By</label>
                    <nz-select
                        id="requestedBy"
                        nzShowSearch
                        style="width: 100%"
                        [(ngModel)]="RequestedByFilter"
                        [ngModelOptions]="{standalone: true}"
                        (ngModelChange)="Refresh()">
                        <nz-option [nzValue]="''" nzLabel="All"></nz-option>
                        @for (requester of Requesters; track requester) {
                            <nz-option [nzValue]="requester.UserID" [nzLabel]="requester.UserName"></nz-option>
                        }
                    </nz-select>
                </div>
            </div>
            <!-- Dashboard table -->
            @if (!Loading && Items.length > 0) {
                <table class="table table-striped">
                    <thead>
                        <tr>
                            @if (DashboardSearch.ShowCanceled) {
                                <th>Actions</th>
                            }
                            <th>Type</th>
                            <th (click)="OrderDashboard('Step.StepName')">
                                Step <span [ngClass]="DashboardSortClass('Step.StepName')"></span>
                            </th>
                            <th (click)="OrderDashboard('CreatedBy')">
                                Requested By <span [ngClass]="DashboardSortClass('CreatedBy')"></span>
                            </th>
                            <th (click)="OrderDashboard('Date')">
                                Date <span [ngClass]="DashboardSortClass('Date')"></span>
                            </th>
                            <th (click)="OrderDashboard('PurchaseOrderNumber')">
                                PO # <span [ngClass]="DashboardSortClass('PurchaseOrderNumber')"></span>
                            </th>
                            <th (click)="OrderDashboard('PurchaseRequestID')">
                                Request # <span [ngClass]="DashboardSortClass('PurchaseRequestID')"></span>
                            </th>
                            <th (click)="OrderDashboard('VendorName')">
                                Vendor Name <span [ngClass]="DashboardSortClass('VendorName')"></span>
                            </th>
                            <th (click)="OrderDashboard('Location.ShippingLocation')">
                                Location <span [ngClass]="DashboardSortClass('Location.ShippingLocation')"></span>
                            </th>
                            <th (click)="OrderDashboard('PurchaseOrder.Payment.DueDate')">
                                Due Date <span [ngClass]="DashboardSortClass('PurchaseOrder.Payment.DueDate')"></span>
                            </th>
                            <th (click)="OrderDashboard('PurchaseOrder.Payment.VendorInvoiceNumber')">
                                Invoice #
                                <span
                                    [ngClass]="DashboardSortClass('PurchaseOrder.Payment.VendorInvoiceNumber')"></span>
                            </th>
                            <th>Items</th>
                            <th (click)="OrderDashboard('Total')">
                                Total <span [ngClass]="DashboardSortClass('Total')"></span>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        @for (Item of Items; track Item) {
                            <tr [ngClass]="{success: Item.Selected}">
                                @if (DashboardSearch.ShowCanceled) {
                                    <td>
                                        @if (isAdmin && Item.Canceled === "Yes") {
                                            <button (click)="RestoreItem(Item)" class="btn btn-default cmd-button">
                                                <span class="cmd-icon"></span><span class="icon-text">Restore</span>
                                            </button>
                                        }
                                        @if (isAdmin && Item.Canceled === "Yes") {
                                            <button
                                                (click)="DeleteItem(Item, deletePRModal)"
                                                class="btn btn-danger cmd-button">
                                                Delete
                                            </button>
                                        }
                                    </td>
                                }
                                <td>
                                    {{ Item.ItemTypeName }}
                                </td>
                                <td>{{ Item.StepName }}</td>
                                <td>{{ Item.CreatedBy }}</td>
                                <td>{{ Item.Date | date: "MM/dd/yyyy" }}</td>
                                <td>
                                    <a style="cursor: pointer" (click)="SelectItem(Item)">{{ Item.PONumber }}</a>
                                </td>
                                <td>
                                    <a style="cursor: pointer" (click)="SelectItem(Item)">{{ Item.PRNumber }}</a>
                                </td>
                                <td>
                                    <a style="cursor: pointer" (click)="SelectItem(Item)">{{ Item.VendorName }}</a>
                                </td>
                                <td>{{ Item.Location }}</td>
                                <td>{{ Item.DueDate | date: "MM/dd/yyyy" }}</td>
                                @if (StepName === "Goods Receipt") {
                                    <td>{{ Item.Received }}</td>
                                }
                                <td>{{ Item.InvoiceNumber }}</td>
                                <td>
                                    @if (Item.ItemType === 1) {
                                        <div
                                            style="cursor: pointer; display: inline"
                                            (click)="SelectItemAndShow(Item, 'attached', 'Payment')"
                                            safeTooltip="{{ Item.AttachedDocuments }}">
                                            <span class="view-icon filesitem-icon"></span>
                                        </div>
                                    }
                                    @if (Item.ItemType === 0) {
                                        <div style="cursor: pointer; display: inline; margin-left: 28px">
                                            <span class="view-icon"></span>
                                        </div>
                                    }
                                    <div
                                        style="cursor: pointer; display: inline"
                                        (click)="SelectItemAndShow(Item, 'history', 'Audit Log')"
                                        safeTooltip="{{ BuildTransactionsTable(Item) }}">
                                        <span class="view-icon transactionitem-icon">&nbsp;</span>
                                    </div>
                                    <div
                                        style="cursor: pointer; display: inline"
                                        (click)="SelectItemAndShow(Item, 'lineitems')"
                                        safeTooltip="{{ Item.LineItems }}">
                                        <span class="view-icon lineitem-icon"></span>
                                    </div>
                                    <div
                                        style="cursor: pointer; display: inline"
                                        (click)="SelectItemAndShow(Item, 'notes')"
                                        safeTooltip="{{ BuildNotesTable(Item) }}">
                                        <span class="view-icon notesitem-icon"></span>
                                    </div>
                                </td>
                                <td>{{ Item.Total }}</td>
                            </tr>
                        }
                    </tbody>
                </table>
            }
        </div>

        <!-- END DASHBOARD -->

        <!-- BEGIN PURCHASE REQUESTS -->

        <div [style.display]="Items && SelectedType === 0 ? 'block' : 'none'">
            <div style="margin-top: 10px"></div>
            <!-- Purchase request search -->
            <div class="row">
                <div class="col-md-12">
                    <div class="d-flex flex-wrap align-items-center gap-2">
                        <nz-select
                            [ngModelOptions]="{standalone: true}"
                            [(ngModel)]="PRSearch.Field"
                            (ngModelChange)="PRFieldChanged()"
                            nzShowSearch
                            nzPlaceHolder="Field"
                            style="width: 160px">
                            @for (s of PRSearchOptions; track s) {
                                <nz-option [nzValue]="s" [nzLabel]="s.SearchOption"></nz-option>
                            }
                        </nz-select>
                        <nz-select
                            [ngModelOptions]="{standalone: true}"
                            [(ngModel)]="PRSearch.Operator"
                            style="width: 110px">
                            <nz-option [nzValue]="'Contains'" [nzLabel]="'Contains'"></nz-option>
                            <nz-option [nzValue]="'='" [nzLabel]="'='"></nz-option>
                            <nz-option [nzValue]="'>'" [nzLabel]="'>'"></nz-option>
                            <nz-option [nzValue]="'>='" [nzLabel]="'>='"></nz-option>
                            <nz-option [nzValue]="'<'" [nzLabel]="'<'"></nz-option>
                            <nz-option [nzValue]="'<='" [nzLabel]="'<='"></nz-option>
                        </nz-select>
                        @if (PRSearch.Field.SearchType !== 1) {
                            <input
                                nz-input
                                type="text"
                                [(ngModel)]="PRSearch.Value"
                                [ngModelOptions]="{standalone: true}"
                                (keyup.enter)="Search()"
                                style="width: 180px" />
                        }
                        @if (PRSearch.Field.SearchType === 1) {
                            <nz-date-picker
                                [(ngModel)]="PRSearch.DateValue"
                                [ngModelOptions]="{standalone: true}"
                                nzFormat="MM/dd/yyyy"
                                style="width: 180px"></nz-date-picker>
                        }
                        @if (OnFirstPRStep()) {
                            <label
                                nz-checkbox
                                class="mb-0 ms-1"
                                [(ngModel)]="PRSearch.ShowCanceled"
                                [ngModelOptions]="{standalone: true}"
                                (ngModelChange)="ToggleCanceled()">
                                Show Canceled
                            </label>
                        }
                        <nz-space-compact>
                            <button nz-button nzType="primary" (click)="Search()">Search</button>
                            <button nz-button (click)="Clear()">Clear</button>
                        </nz-space-compact>
                    </div>
                </div>
            </div>
            @if (!OnFirstPRStep() || (OnFirstPRStep() && !PRSearch.ShowCanceled)) {
                <div class="row" style="margin-top: 10px">
                    @if (!AnySelected() && SelectedType === 0 && SelectedShowsCreate) {
                        <div class="col-md-12">
                            <button nz-button nzType="primary" class="pf-btn-success" (click)="CreateRequest()">
                                Create Request
                            </button>
                        </div>
                    }
                    @if (AnySelected()) {
                        <div class="col-md-12">
                            <button
                                type="button"
                                class="btn btn-secondary dropdown-toggle"
                                data-toggle="dropdown"
                                aria-expanded="false"
                                aria-haspopup="true">
                                Actions On <span class="caret"></span>
                            </button>
                            <ul class="dropdown-menu">
                                @if (AnyApprovableItemsSelected()) {
                                    <li>
                                        <a
                                            class="dropdown-item"
                                            href="#"
                                            (click)="
                                                GetSelectedApprovableItems();
                                                modal.open(approveMultiplePRModal, ModalOptions)
                                            "
                                            >Approve</a
                                        >
                                    </li>
                                }
                                @if (StepName === "Request") {
                                    <li>
                                        <a
                                            class="dropdown-item"
                                            href="#"
                                            (click)="
                                                GetSelectedApprovableItems();
                                                CancelMultiple(GetSelectedItems()[0], cancelMultipleModal)
                                            "
                                            >Cancel</a
                                        >
                                    </li>
                                }
                                <li>
                                    <a class="dropdown-item" href="#" (click)="ToggleCanceled()">Clear Selections</a>
                                </li>
                            </ul>
                            <span style="font-weight: bold"
                                >{{ SelectedItemsCount() }} of {{ CurrentPageResultCount() }} selected</span
                            >
                        </div>
                    }
                </div>
            }
            <!-- Purchase request table -->
            @if (!Loading && Items.length > 0) {
                <table class="table table-striped">
                    <thead>
                        <tr>
                            @if (!PRSearch.ShowCanceled) {
                                <th style="width: 20px">
                                    <input
                                        style="margin-top: 12px"
                                        type="checkbox"
                                        [ngModelOptions]="{standalone: true}"
                                        [(ngModel)]="CheckAllItems"
                                        (ngModelChange)="CheckItemsChanged()" />
                                </th>
                            }
                            <th>Actions</th>
                            <th (click)="OrderPr('CreatedByUser.UserName')">
                                Requested By <span [ngClass]="PrSortClass('CreatedByUser.UserName')"></span>
                            </th>
                            <th (click)="OrderPr('Date')">
                                Request Date <span [ngClass]="PrSortClass('Date')"></span>
                            </th>
                            <th (click)="OrderPr('PurchaseRequestId')">
                                Request # <span [ngClass]="PrSortClass('PurchaseRequestId')"></span>
                            </th>
                            <th (click)="OrderPr('VendorName')">
                                Vendor Name <span [ngClass]="PrSortClass('VendorName')"></span>
                            </th>
                            <th>Items</th>
                            <th (click)="OrderPr('Total')">Total <span [ngClass]="PrSortClass('Total')"></span></th>
                        </tr>
                    </thead>
                    <tbody>
                        @for (PR of Items; track PR) {
                            <tr [ngClass]="{success: PR.Selected}">
                                @if (!PRSearch.ShowCanceled) {
                                    <td>
                                        @if ((PR.Canceled ?? "No") === "No") {
                                            <input
                                                style="margin-top: 12px"
                                                type="checkbox"
                                                [(ngModel)]="PR.Selected"
                                                [ngModelOptions]="{standalone: true}" />
                                        }
                                    </td>
                                }
                                @if (!PRSearch.ShowCanceled) {
                                    <td>
                                        @if (PR.Canceled === "No") {
                                            <button nz-button class="pf-cmd-btn" (click)="ApprovePR(PR)">
                                                <img src="assets/images/ptp/approve.png" alt="" /><span
                                                    class="icon-text"
                                                    >Approve</span
                                                >
                                            </button>
                                        }
                                        @if (!OnFirstPRStep() && PR.DenyVisible) {
                                            <button nz-button class="pf-cmd-btn" (click)="DenyItem(PR, denyModal)">
                                                <img src="assets/images/ptp/deny.png" alt="" /><span class="icon-text"
                                                    >Deny</span
                                                >
                                            </button>
                                        }
                                    </td>
                                }
                                @if (OnFirstPRStep() && PRSearch.ShowCanceled) {
                                    <td>
                                        @if (isAdmin && PR.Canceled === "Yes") {
                                            <button (click)="RestoreItem(PR)" class="btn btn-default cmd-button">
                                                <span class="cmd-icon"></span><span class="icon-text">Restore</span>
                                            </button>
                                        }
                                        @if (isAdmin && PR.Canceled === "Yes") {
                                            <button
                                                (click)="DeleteItem(PR, deletePRModal)"
                                                class="btn btn-danger cmd-button">
                                                Delete
                                            </button>
                                        }
                                    </td>
                                }
                                <!--
                          <td>
                            <button *ngIf="isAdmin && PR.Canceled == 'Yes'"
                              (click)="RestoreItem(PR)" class="btn btn-default cmd-button">
                              <span class="cmd-icon"></span><span class="icon-text">Restore</span>
                            </button>
                            <button *ngIf="isAdmin && PR.Canceled == 'Yes'"
                              (click)="DeleteItem(PR, deletePRModal)"
                              class="btn btn-danger cmd-button">
                              Delete
                            </button>
                            <button *ngIf="PR.Canceled == 'No'" (click)="ApproveItem(PR)"
                              class="btn btn-default cmd-button">
                              <span class="cmd-icon approve-icon"></span><span class="icon-text">Approve</span>
                            </button>
                            <button (click)="CancelItem(PR, cancelModal)" *ngIf="PR.Canceled == 'No'"
                              class="btn btn-default cmd-button">
                              <span class="cmd-icon deny-icon"></span><span class="icon-text">Cancel</span>
                            </button>
                          </td>
                          -->
                                <!-- <td *ngIf="PRSearch.ShowCanceled">{{ PR.Canceled }}</td> -->
                                <td>{{ PR.CreatedBy }}</td>
                                <td>{{ PR.Date | date: "MM/dd/yyyy" }}</td>
                                <td>
                                    <a style="cursor: pointer" (click)="SelectItem(PR)">{{ PR.PRID }}</a>
                                </td>
                                <td>
                                    <a style="cursor: pointer" (click)="SelectItem(PR)">{{ PR.VendorName }}</a>
                                </td>
                                <td>
                                    <div
                                        style="cursor: pointer; display: inline"
                                        (click)="SelectItemAndShow(PR, 'history', 'Audit Log')"
                                        safeTooltip="{{ BuildTransactionsTable(PR) }}">
                                        <span class="view-icon transactionitem-icon"></span>
                                    </div>
                                    <div
                                        style="cursor: pointer; display: inline"
                                        (click)="SelectItemAndShow(PR, 'lineitems')"
                                        safeTooltip="{{ PR.LineItems }}">
                                        <span class="view-icon lineitem-icon"></span>
                                    </div>
                                    <div
                                        style="cursor: pointer; display: inline"
                                        (click)="SelectItemAndShow(PR, 'notes')"
                                        safeTooltip="{{ BuildNotesTable(PR) }}">
                                        <span class="view-icon notesitem-icon"></span>
                                    </div>
                                </td>
                                <td>{{ PR.Total }}</td>
                            </tr>
                        }
                    </tbody>
                </table>
            }
        </div>

        <!-- END PURCHASE REQUESTS -->

        <!-- BEGIN PURCHASE ORDERS -->

        <div [style.display]="Items && SelectedType === 1 ? 'block' : 'none'">
            <div style="margin-top: 10px"></div>
            <!-- Purchase order search -->
            <div class="row">
                <div class="col-md-12">
                    <div class="d-flex flex-wrap align-items-center gap-2">
                        <nz-select
                            [ngModelOptions]="{standalone: true}"
                            [(ngModel)]="POSearch.Field"
                            (ngModelChange)="POFieldChanged()"
                            nzShowSearch
                            nzPlaceHolder="Field"
                            style="width: 160px">
                            @for (s of POSearchOptions; track s) {
                                <nz-option [nzValue]="s" [nzLabel]="s.SearchOption"></nz-option>
                            }
                        </nz-select>
                        <nz-select
                            [ngModelOptions]="{standalone: true}"
                            [(ngModel)]="POSearch.Operator"
                            style="width: 110px">
                            <nz-option [nzValue]="'Contains'" [nzLabel]="'Contains'"></nz-option>
                            <nz-option [nzValue]="'='" [nzLabel]="'='"></nz-option>
                            <nz-option [nzValue]="'>'" [nzLabel]="'>'"></nz-option>
                            <nz-option [nzValue]="'>='" [nzLabel]="'>='"></nz-option>
                            <nz-option [nzValue]="'<'" [nzLabel]="'<'"></nz-option>
                            <nz-option [nzValue]="'<='" [nzLabel]="'<='"></nz-option>
                        </nz-select>
                        @if (POSearch.Field.SearchType !== 1) {
                            <input
                                nz-input
                                type="text"
                                [(ngModel)]="POSearch.Value"
                                [ngModelOptions]="{standalone: true}"
                                (keyup.enter)="Search()"
                                style="width: 160px" />
                        }
                        @if (POSearch.Field.SearchType === 1) {
                            <nz-date-picker
                                [(ngModel)]="POSearch.DateValue"
                                [ngModelOptions]="{standalone: true}"
                                nzFormat="MM/dd/yyyy"
                                style="width: 160px"></nz-date-picker>
                        }
                        <nz-space-compact>
                            <button nz-button nzType="primary" (click)="Search()">Search</button>
                            <button nz-button (click)="Clear()">Clear</button>
                        </nz-space-compact>
                    </div>
                </div>
            </div>
            <div class="row" style="margin-top: 10px">
                @if (!AnySelected() && SelectedType === 1 && SelectedShowsCreate) {
                    <div class="col-md-12">
                        <button nz-button nzType="primary" class="pf-btn-success" (click)="CreatePO()">
                            Create PO
                        </button>
                    </div>
                }
                @if (AnySelected()) {
                    <div class="col-md-12">
                        <button
                            type="button"
                            class="btn btn-secondary dropdown-toggle"
                            data-toggle="dropdown"
                            aria-expanded="false"
                            aria-haspopup="true">
                            Actions On <span class="caret"></span>
                        </button>
                        <ul class="dropdown-menu">
                            @if (AnyApprovableItemsSelected()) {
                                <li>
                                    <a
                                        class="dropdown-item"
                                        href="#"
                                        (click)="modal.open(approveMultiplePOModal, ModalOptions)"
                                        >Approve</a
                                    >
                                </li>
                            }
                            @if (AnyApprovableItemsSelected()) {
                                <li>
                                    <a class="dropdown-item" href="#" (click)="modal.open(checkModal, ModalOptions)"
                                        >Apply Check</a
                                    >
                                </li>
                            }
                            <li>
                                <a class="dropdown-item" href="#" (click)="modal.open(deletePoModal, ModalOptions)"
                                    >Delete</a
                                >
                            </li>
                            <li><a class="dropdown-item" href="#" (click)="ToggleCanceled()">Clear Selections</a></li>
                        </ul>
                        <span style="font-weight: bold"
                            >{{ SelectedItemsCount() }} of {{ CurrentPageResultCount() }} selected</span
                        >
                    </div>
                }
            </div>
            <!-- Purchase order table -->
            @if (!Loading && Items.length > 0) {
                <table class="table table-striped">
                    <thead>
                        <tr>
                            <th style="width: 20px">
                                <input
                                    style="margin-top: 12px"
                                    type="checkbox"
                                    [ngModelOptions]="{standalone: true}"
                                    [(ngModel)]="CheckAllItems"
                                    (ngModelChange)="CheckItemsChanged()" />
                            </th>
                            <th>Actions</th>
                            <th (click)="OrderPo('Date')">PO Date <span [ngClass]="PoSortClass('Date')"></span></th>
                            <th (click)="OrderPo('PurchaseOrderNumber')">
                                PO # <span [ngClass]="PoSortClass('PurchaseOrderNumber')"></span>
                            </th>
                            <th (click)="OrderPo('VendorName')">
                                Vendor Name <span [ngClass]="PoSortClass('VendorName')"></span>
                            </th>
                            <th (click)="OrderPo('Payment.DueDate')">
                                Due Date <span [ngClass]="PoSortClass('Payment.DueDate')"></span>
                            </th>
                            @if (StepName === "Goods Receipt") {
                                <th (click)="OrderPo('Received')">
                                    Received <span [ngClass]="PoSortClass('Received')"></span>
                                </th>
                            }
                            <th (click)="OrderPo('Payment.VendorInvoiceNumber')">
                                Invoice # <span [ngClass]="PoSortClass('Payment.VendorInvoiceNumber')"></span>
                            </th>
                            <th>Items</th>
                            <th (click)="OrderPo('Total')">Total <span [ngClass]="PoSortClass('Total')"></span></th>
                        </tr>
                    </thead>
                    <tbody>
                        @for (PO of Items; track PO) {
                            <tr [ngClass]="{success: PO.Selected}">
                                <td>
                                    <input
                                        style="margin-top: 12px"
                                        type="checkbox"
                                        [(ngModel)]="PO.Selected"
                                        [ngModelOptions]="{standalone: true}" />
                                </td>
                                <td>
                                    @if (PO.ApproveVisible) {
                                        <button nz-button class="pf-cmd-btn" (click)="ApprovePO(PO)">
                                            <img src="assets/images/ptp/approve.png" alt="" /><span class="icon-text"
                                                >Approve</span
                                            >
                                        </button>
                                    }
                                    @if (PO.DenyVisible) {
                                        <button nz-button class="pf-cmd-btn" (click)="DenyItem(PO, denyModal)">
                                            <img src="assets/images/ptp/deny.png" alt="" /><span class="icon-text"
                                                >Deny</span
                                            >
                                        </button>
                                    }
                                </td>
                                <td>{{ PO.Date | date: "MM/dd/yyyy" }}</td>
                                <td>
                                    <a style="cursor: pointer" (click)="SelectItem(PO)">{{ PO.PONumber }}</a>
                                </td>
                                <td>
                                    <a style="cursor: pointer" (click)="SelectItem(PO)">{{ PO.VendorName }}</a>
                                </td>
                                <td>{{ PO.DueDate | date: "MM/dd/yyyy" }}</td>
                                @if (StepName === "Goods Receipt") {
                                    <td>{{ PO.Received }}</td>
                                }
                                <td>{{ PO.InvoiceNumber }}</td>
                                <td>
                                    <div
                                        style="cursor: pointer; display: inline"
                                        (click)="SelectItemAndShow(PO, 'attached', 'Payment')"
                                        safeTooltip="{{ PO.AttachedDocuments }}">
                                        <span class="view-icon filesitem-icon"></span>
                                    </div>
                                    <div
                                        style="cursor: pointer; display: inline"
                                        (click)="SelectItemAndShow(PO, 'history', 'Audit Log')"
                                        safeTooltip="{{ BuildTransactionsTable(PO) }}">
                                        <span class="view-icon transactionitem-icon"></span>
                                    </div>
                                    <div
                                        style="cursor: pointer; display: inline"
                                        (click)="SelectItemAndShow(PO, 'lineitems')"
                                        safeTooltip="{{ PO.LineItems }}">
                                        <span class="view-icon lineitem-icon"></span>
                                    </div>
                                    <div
                                        style="cursor: pointer; display: inline"
                                        (click)="SelectItemAndShow(PO, 'notes')"
                                        safeTooltip="{{ BuildNotesTable(PO) }}">
                                        <span class="view-icon notesitem-icon"></span>
                                    </div>
                                </td>
                                <td>{{ PO.Total }}</td>
                            </tr>
                        }
                    </tbody>
                </table>
            }
        </div>

        <!-- END PURCHASE ORDERS -->

        <!-- shared loading skeleton + empty state for the grid tabs (Request / PO / Dashboard) -->
        @if (Loading && SelectedType !== 2) {
            <app-ptp-grid-skeleton
                [type]="SelectedType"
                [stepName]="StepName"
                [showCanceled]="DashboardSearch.ShowCanceled"
                [rows]="ResultCount"></app-ptp-grid-skeleton>
        }
        @if (!Loading && SelectedType !== 2 && Items.length === 0) {
            <nz-empty nzNotFoundContent="No items" style="margin-top: 24px"></nz-empty>
        }

        <!-- BEGIN REPORTS -->

        @if (SelectedType === 2 && StepName === "Report") {
            <div>
                <div style="margin-top: 10px">
                    Date Range:
                    {{ FromDate ? (formatter.format(FromDate) | date) : "Any" }} To:
                    {{ ToDate ? (formatter.format(ToDate) | date) : "Any" }}
                </div>
                <div style="margin-top: 10px">
                    <ngb-datepicker
                        #dp
                        (dateSelect)="OnDateSelection($event)"
                        [displayMonths]="2"
                        [dayTemplate]="t"
                        outsideDays="hidden">
                    </ngb-datepicker>
                </div>
                @if (FromDate || ToDate) {
                    <button style="margin-top: 10px" (click)="ResetDates()" type="button" class="btn btn-primary">
                        Reset
                    </button>
                }
                <ng-template #t let-date let-focused="focused">
                    <span
                        class="custom-day"
                        [class.focused]="focused"
                        [class.range]="IsRange(date)"
                        [class.faded]="IsHovered(date) || IsInside(date)">
                        {{ date.day }}
                    </span>
                </ng-template>
                <hr />
                <div style="margin-top: 25px"></div>
                <div class="row">
                    <div class="col-md-4">
                        <h3 style="text-align: center">Dollars by Department</h3>
                        <div style="margin-top: 25px"></div>
                        @if (pieChartData) {
                            <canvas
                                baseChart
                                [options]="pieChartOptions"
                                class="chart"
                                [type]="'pie'"
                                [data]="pieChartData"
                                [labels]="Labels">
                            </canvas>
                        }
                        <table class="table table-striped">
                            <thead>
                                <tr>
                                    <th><b>Department</b></th>
                                    <th><b>Dollars</b></th>
                                </tr>
                            </thead>
                            @for (row of Data; track row; let index = $index) {
                                <tr>
                                    <td>{{ Labels[index] }}</td>
                                    <td>{{ row | currency }}</td>
                                </tr>
                            }
                        </table>
                    </div>
                    <div class="col-md-4">
                        <h3 style="text-align: center">Dollars by Month</h3>
                        <div style="margin-top: 25px"></div>
                        @if (barChartData2) {
                            <canvas
                                baseChart
                                class="chart"
                                [type]="'bar'"
                                [options]="{responsive: true}"
                                [data]="barChartData2"
                                [labels]="Labels2">
                            </canvas>
                        }
                        <table class="table table-striped">
                            <thead>
                                <tr>
                                    <th><b>Month</b></th>
                                    <th><b>Dollars</b></th>
                                </tr>
                            </thead>
                            @if (Data2 && Data2.length > 0) {
                                @for (row of Data2[0]; track row; let index = $index) {
                                    <tr>
                                        <td>{{ Labels2[index] }}</td>
                                        <td>{{ row | currency }}</td>
                                    </tr>
                                }
                            }
                        </table>
                    </div>
                    <div class="col-md-4">
                        <h3 style="text-align: center">Dollars by Vendor</h3>
                        <div style="margin-top: 25px"></div>
                        @if (pieChartData3) {
                            <canvas
                                baseChart
                                [options]="pieChartOptions"
                                class="chart"
                                [type]="'pie'"
                                [data]="pieChartData3"
                                [labels]="Labels3">
                            </canvas>
                        }
                        <table class="table table-striped">
                            <thead>
                                <tr>
                                    <th><b>Vendor</b></th>
                                    <th><b>Dollars</b></th>
                                </tr>
                            </thead>
                            @for (row of Data3; track row; let index = $index) {
                                <tr>
                                    <td>{{ Labels3[index] }}</td>
                                    <td>{{ row | currency }}</td>
                                </tr>
                            }
                        </table>
                    </div>
                    <div class="col-md-4">
                        <h3 style="text-align: center">Dollars by Location</h3>
                        <div style="margin-top: 25px"></div>
                        @if (pieChartData4) {
                            <canvas
                                baseChart
                                [options]="pieChartOptions"
                                class="chart"
                                [type]="'pie'"
                                [data]="pieChartData4"
                                [labels]="Labels4">
                            </canvas>
                        }
                        <table class="table table-striped">
                            <thead>
                                <tr>
                                    <th><b>Location</b></th>
                                    <th><b>Dollars</b></th>
                                </tr>
                            </thead>
                            @for (row of Data4; track row; let index = $index) {
                                <tr>
                                    <td>{{ Labels4[index] }}</td>
                                    <td>{{ row | currency }}</td>
                                </tr>
                            }
                        </table>
                    </div>
                    <div class="col-md-4">
                        <h3 style="text-align: center">Dollars by Approver</h3>
                        <div style="margin-top: 25px"></div>
                        @if (pieChartData5) {
                            <canvas
                                baseChart
                                [options]="pieChartOptions"
                                class="chart"
                                [type]="'pie'"
                                [data]="pieChartData5"
                                [labels]="Labels5">
                            </canvas>
                        }
                        <table class="table table-striped">
                            <thead>
                                <tr>
                                    <th><b>Approver</b></th>
                                    <th><b>Dollars</b></th>
                                </tr>
                            </thead>
                            @for (row of Data5; track row; let index = $index) {
                                <tr>
                                    <td>{{ Labels5[index] }}</td>
                                    <td>{{ row | currency }}</td>
                                </tr>
                            }
                        </table>
                    </div>
                </div>
            </div>
        }

        <!-- END REPORTS -->

        <!-- BEGIN PAGING -->

        @if (!Loading && Items.length > 0 && CurrentSearch && SelectedType !== 2) {
            <div class="col-md-12">
                <div class="row">
                    <div class="col-md-12" style="display: flex; flex-direction: row; justify-content: space-between">
                        <div style="display: flex; flex-direction: row; align-items: center">
                            <ngb-pagination
                                style="display: inline-block"
                                size="sm"
                                [collectionSize]="CurrentSearch.Results"
                                [(page)]="Page"
                                [maxSize]="5"
                                [pageSize]="ResultCount"
                                [rotate]="true"
                                [ellipses]="true"
                                (pageChange)="PageChange($event)"
                                [boundaryLinks]="true"></ngb-pagination>
                            <div style="margin-left: 15px; margin-top: -4px">
                                Display:
                                <nz-select
                                    style="width: 80px"
                                    [(ngModel)]="ResultCount"
                                    [ngModelOptions]="{standalone: true}"
                                    (ngModelChange)="SetResultCount()">
                                    @for (o of DisplayOptions; track o) {
                                        <nz-option [nzValue]="o" [nzLabel]="o + ''"></nz-option>
                                    }
                                </nz-select>
                            </div>
                        </div>
                        <div>
                            Page {{ CurrentSearch.Page }} of {{ CurrentSearch.PageTotal }} ({{ CurrentSearch.Results }}
                            total)
                        </div>
                    </div>
                </div>
            </div>
        }

        <!-- END PAGING -->
    </div>

    <!-- BEGIN TEMPLATES -->

    <ng-template #cancelModal>
        <div class="modal-header">Cancel {{ this.CancelRequest.CancelType === 0 ? "Request" : "Order" }}</div>
        <form (ngSubmit)="DoCancelItem()" role="form">
            <div class="modal-body">
                <div class="form-group">
                    <div class="control-label">Reason (optional)</div>
                    <textarea
                        name="cancelNotes"
                        [(ngModel)]="CancelRequest.CancelNotes"
                        [ngModelOptions]="{standalone: true}"
                        class="form-control"
                        style="height: 100px; margin-bottom: 15px"></textarea>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-default" (click)="CloseModal()">Cancel</button>
                <button type="submit" class="btn btn-danger">Cancel Request</button>
            </div>
        </form>
    </ng-template>
    <ng-template #cancelMultipleModal>
        <div class="modal-header">Cancel {{ GetSelectedItems().length }} Requests</div>
        <form (ngSubmit)="CancelMultipleRequests()" role="form">
            <div class="modal-body">
                <div class="form-group">
                    <div>
                        <strong>Selection</strong>
                    </div>
                    <div style="max-height: 100px; overflow-y: auto">
                        @for (PR of GetSelectedItems(); track PR) {
                            <div>Request #{{ PR.PRID }} ({{ PR.VendorName }})</div>
                        }
                    </div>
                </div>
                <div class="form-group">
                    <div class="control-label">Reason (optional)</div>
                    <textarea
                        name="cancelNotes"
                        [(ngModel)]="CancelRequest.CancelNotes"
                        [ngModelOptions]="{standalone: true}"
                        class="form-control"
                        style="height: 100px; margin-bottom: 15px"></textarea>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-default" (click)="CloseModal()">Cancel</button>
                <button type="submit" class="btn btn-danger">Cancel Requests</button>
            </div>
        </form>
    </ng-template>
    <ng-template #checkModal>
        <div class="modal-header">Apply Check Number</div>
        <form (ngSubmit)="DoApplyCheckNumber()" role="form">
            <div class="modal-body">
                <div class="form-group">
                    <span style="font-size: 10px">Enter the check number you wish to apply to the selected POs.</span>
                </div>
                <div class="form-group">
                    <div>
                        <strong>Selection</strong>
                    </div>
                    <div style="max-height: 100px; overflow-y: auto">
                        @for (PO of GetSelectedItems(); track PO) {
                            <div>PO #{{ PO.PONumber }} ({{ PO.VendorName }})</div>
                        }
                    </div>
                </div>
                <div class="form-group">
                    <label for="checkNumber">Check Number</label>
                    <input
                        name="checkNumber"
                        type="text"
                        [(ngModel)]="CheckRequest.CheckNumber"
                        [ngModelOptions]="{standalone: true}"
                        class="form-control"
                        style="margin-bottom: 15px" />
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-default" (click)="CloseModal()">Cancel</button>
                <button type="submit" class="btn btn-primary">Apply</button>
            </div>
        </form>
    </ng-template>
    <ng-template #denyModal>
        <div class="modal-header">Deny {{ this.DenyRequest.DenyType === 0 ? "Request" : "Order" }}</div>
        <form (ngSubmit)="DoDenyItem()" role="form">
            <div class="modal-body">
                <div class="form-group">
                    <label for="denyNotes">Reason (optional)</label>
                    <textarea
                        name="denyNotes"
                        [(ngModel)]="DenyRequest.DenyNotes"
                        [ngModelOptions]="{standalone: true}"
                        class="form-control"
                        style="height: 100px; margin-bottom: 15px"></textarea>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-default" (click)="CloseModal()">Cancel</button>
                <button type="submit" class="btn btn-danger">
                    Deny {{ this.DenyRequest.DenyType === 0 ? "Request" : "Order" }}
                </button>
            </div>
        </form>
    </ng-template>
    <ng-template #deletePoModal>
        <div class="modal-header">Delete PO</div>
        <form (ngSubmit)="DoDeletePO()" role="form">
            <div class="modal-body">
                <div class="form-group">
                    <div>
                        <strong>Selection</strong>
                    </div>
                    <div style="max-height: 100px; overflow-y: auto">
                        @for (PO of GetSelectedItems(); track PO) {
                            <div>PO #{{ PO.PONumber }} ({{ PO.VendorName }})</div>
                        }
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-default" (click)="CloseModal()">Cancel</button>
                <button type="submit" class="btn btn-danger">Delete</button>
            </div>
        </form>
    </ng-template>
    <ng-template #approveMultiplePRModal>
        <div class="modal-header">Approve {{ GetSelectedItems().length }} Requests</div>
        <form (ngSubmit)="ApproveMultipleItems()" role="form">
            <div class="modal-body">
                <div class="form-group">
                    <div>
                        <strong>Selection</strong>
                    </div>
                    <div style="max-height: 100px; overflow-y: auto">
                        @for (PR of GetSelectedItems(); track PR) {
                            <div>Request #{{ PR.PRID }} ({{ PR.VendorName }})</div>
                        }
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-default" (click)="CloseModal()">Cancel</button>
                <button type="submit" class="btn btn-primary">Approve Requests</button>
            </div>
        </form>
    </ng-template>
    <ng-template #approveMultiplePOModal>
        <div class="modal-header">Approve {{ GetSelectedItems().length }} POs</div>
        <form (ngSubmit)="ApproveMultipleItems()" role="form">
            <div class="modal-body">
                <div class="form-group">
                    <div>
                        <strong>Selection</strong>
                    </div>
                    <div style="max-height: 100px; overflow-y: auto">
                        @for (PO of GetSelectedItems(); track PO) {
                            <div>PO #{{ PO.PONumber }} ({{ PO.VendorName }})</div>
                        }
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-default" (click)="CloseModal()">Cancel</button>
                <button type="submit" class="btn btn-primary">Approve POs</button>
            </div>
        </form>
    </ng-template>
    <!-- restoreMultiplePRModal - not currently used -->
    <!--
                          <ng-template #restoreMultiplePRModal>
                            <div class="modal-header">Restore Requests</div>
                            <form (ngSubmit)="RestoreMultipleItems()" role="form">
                              <div class="modal-body">
                                <div class="form-group">
                                  <label>Selection</label>
                                  <div style="max-height: 100px; overflow-y: auto">
                                    <div *ngFor="let PR of GetSelectedItems()">{{ PR.VendorName }}</div>
                                  </div>
                                </div>
                              </div>
                              <div class="modal-footer">
                                <button type="button" class="btn btn-default" (click)="CloseModal()">Cancel</button>
                                <button type="submit" class="btn btn-primary">Restore Items</button>
                              </div>
                            </form>
                          </ng-template>
                          -->
    <ng-template #deletePRModal>
        <div class="modal-header">Delete Request</div>
        <form (ngSubmit)="DoDeleteRequest()" role="form">
            <div class="modal-body">
                <div class="form-group">
                    <div>
                        <strong>Request #{{ DeleteRequest.DeleteID }} ({{ DeleteRequest.VendorName }})</strong>
                    </div>
                    <div>Are you sure you want to delete this request?</div>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-default" (click)="CloseModal()">Cancel</button>
                <button type="submit" class="btn btn-danger">Delete Request</button>
            </div>
        </form>
    </ng-template>

    <!-- END TEMPLATES -->
</div>
